import { useEffect, useState } from 'react'
import React from 'react'
import sec from '../assets/Images/home-secure/secure.png'
import competitive from '../assets/Images/home-secure/competitive 1icons.png'
import quality from '../assets/Images/home-secure/quality-2 1icons.png'
import reliability from '../assets/Images/home-secure/reliability 1icons.png'
import logofoot from '../assets/Images/logo-foot.png';
// import { useEffect } from 'react';

function Secure() {
    useEffect(() => {
        window.scrollTo(0, 0)


    });
    return (
        <>
            <section className={'mt-5'}>
                <div className='sec-sections'>
                    <div className='w-50 divSecure'>
                        <div className='quick text-black'>
                            <h2 className='pb-1 mb-5'>Quick and easy <br />to get started</h2>
                            {/* <h2 className='pb-1'></h2> */}
                            <p><img src={reliability} width='50' height='50' />INNOVATE ADDED-VALUE SERVICES</p>
                            <p><img src={quality} width='50' height='50' />COMMITED TO EXCELLENCE</p>
                            <p><img src={competitive} width='50' height='50' />COMPETITIVELY PRICED</p>
                        </div>
                    </div>
                    <div className=' sec-img d-flex justify-content-center'>
                        <img src={sec} alt="" />
                        <div className='success sec-card'>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Secure